import { createColumnHelper } from "@tanstack/react-table";
import {
  ArrowDownTrayIcon,
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
const columnHelper = createColumnHelper();

export const inventorySparesTableColumnsConfig = (
  handleOpenModal,
  handleDownload,
  handleProductList
) => [
  columnHelper.accessor("request_id", {
    header: "Request Id",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("seller_name", {
    header: "Seller Name",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("quantity", {
    header: "Quantity",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("approval_status", {
    header: "Approval Status",
    cell: ({ getValue, row }) => {
      const status = getValue();

      const statusConfig = {
        approved: {
          label: "Approved",
          bg: "#E6F7EF",
          color: "#00A167",
          Icon: CheckCircleIcon,
        },
        pending: {
          label: "Pending",
          bg: "#FFF4E5",
          color: "#FF8C00",
          Icon: ClockIcon,
        },
        rejected: {
          label: "Rejected",
          bg: "#FDECEC",
          color: "#E53935",
          Icon: XCircleIcon,
        },
      };

      const config = statusConfig[status];

      if (!config) return "-";

      const { label, bg, color, Icon } = config;

      return (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "4px 10px",
            borderRadius: "999px",
            fontSize: "12px",
            fontWeight: 500,
            backgroundColor: bg,
            color,
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          onClick={() => handleOpenModal(row.original)}
        >
          <Icon style={{ width: 14, height: 14 }} />
          {label}
        </div>
      );
    },
    footer: (props) => props.column.id,
  }),

  columnHelper.display({
    id: "download",
    header: <div style={{ textAlign: "center" }}>Download</div>,
    cell: (props) => (
      <div
        style={{ display: "flex", justifyContent: "center", columnGap: "10px" }}
      >
        <button
          disabled={props.row.original.approval_status === "pending for status"}
          style={{
            display: "flex",
            alignItems: "center",
            columnGap: "6px",
            padding: "6px 12px",
            background: "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",
            color: "#FFFFFF",
            fontWeight: 500,
            fontSize: "13px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #5561A0 0%, #7B82C0 100%)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(47,53,103,0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(47,53,103,0.3)";
          }}
          onClick={() => handleDownload(props.row.original.request_id)}
        >
          <ArrowDownTrayIcon
            style={{
              width: "16px",

              cursor: "pointer",
            }}
          />
          Download
        </button>
      </div>
    ),
  }),
  columnHelper.display({
    id: "actions",
    header: <div style={{ textAlign: "center" }}>Action</div>,
    cell: (props) => (
      <div
        style={{ display: "flex", justifyContent: "center", columnGap: "10px" }}
      >
        <button
          disabled={props.row.original.approval_status === "pending for status"}
          onClick={() => handleProductList(props.row.original.request_id)}
          style={{
            padding: "6px 12px",
            background: "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",
            color: "#FFFFFF",
            fontWeight: 500,
            fontSize: "13px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #5561A0 0%, #7B82C0 100%)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(47,53,103,0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(47,53,103,0.3)";
          }}
        >
          View Inventory
        </button>
        {/* <button
          style={{
            width: "76px",
            color: "#FFFFFF",
            fontSize: "12px",
            lineHeight: "12px",
            fontWeight: 500,
            fontFamily: "Poppins, sans",
            backgroundColor:
              props.row.original.approval_status === "approved"
                ? "#00A167"
                : props.row.original.approval_status === "pending"
                ? "#FF6F3F"
                : "#FF0000",
            borderRadius: "4px",
            padding: "8px",
            border: "none",
            cursor: "pointer",
          }}
          onClick={() => handleOpenModal(props.row.original)}
        >
          {props.row.original.approval_status === "approved"
            ? "Approved"
            : props.row.original.approval_status === "pending"
            ? "Pending"
            : "Rejected"}
        </button> */}
      </div>
    ),
  }),
];
